import React from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from 'reactstrap';
import { BadgePlus } from 'lucide-react';

const FilterDropdown = ({ selectedOptions, singleSelect = false, allowToggleSingle = false, handleFilterChange, resetFilters, options, filterName }) => {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  // const radioName = React.useId();
  return (
    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
      <DropdownToggle
        caret
        size='m'
        color='light'
        style={{
          backgroundColor: 'white',
          color: 'black !important',
          borderColor: '#ced4da',
          borderRadius: '8px'
        }}
      >
        <BadgePlus size={22} color='black' className='pe-2' />
        {filterName}
      </DropdownToggle>

      <DropdownMenu style={{ padding: '5px', margin: '0', fontSize: '14px' }}>
        {options.map((status) => (
          <DropdownItem key={status.key} toggle={false} style={{ padding: '5px 10px', cursor: 'pointer' }} onClick={() => handleFilterChange(status.key)}>
            <Input 
              type={singleSelect ? 'radio' : 'checkbox'}
              name={singleSelect ? 'lng' : undefined}
              checked={selectedOptions.includes(status.key)} 
              readOnly className='me-2' 
            />
            {status.icon}
            <span className='ms-2'>{status.label}</span>
          </DropdownItem>
        ))}

        <DropdownItem divider />
        <DropdownItem style={{ color: 'red', textAlign: 'center' }} onClick={resetFilters}>
          Reset Filter
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default FilterDropdown;
